import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import R from 'ramda';

const styles = StyleSheet.create({
  extraInnerTextContainer: { display: 'flex', alignItems: 'center', flexDirection: 'column', width: '50%' },
  text: { display: 'flex', alignItems: 'center', width: '100%' },
});
const findByDescription = descr => R.find(R.propEq('description', descr));
const getNettValue = descr => R.compose(R.propOr('0.0000', 'nettRate'), findByDescription(descr), R.reject(R.propEq('notApplicable', true)), R.prop('rates'));
const findIndexByDescription = descr => R.findIndex(R.propEq('description', descr));

const SingleExtra = ({ extra, updateWithKey }) => {
  return (
    <div className={css(styles.extraInnerTextContainer)}>
      <div className={css(styles.text)}>
        <i>Type:&nbsp;</i>{extra.extraType}
      </div>
      <div className={css(styles.text)}>
        <i>Code:&nbsp;</i>{extra.extraCode ? ` ${extra.extraCode}` : ' N/A'}
      </div>
      <div className={css(styles.text)}>
        <div style={{ width: '20%' }}>Adult: </div>&nbsp;
        <input
          defaultValue={extra.adult}
          type="number"
          onChange={({ target: { value } }) => {
            updateWithKey('adult', value);
          }}
        />
      </div>
      <div className={css(styles.text)}>
        <div style={{ width: '20%' }}>Child: </div>&nbsp;
        <input
          defaultValue={extra.child}
          type="number"
          onChange={({ target: { value } }) => {
            updateWithKey('child', value);
          }}
        />
      </div>
      <div className={css(styles.text)}>
        <div style={{ width: '20%' }}>Infant: </div>&nbsp;
        <input
          defaultValue={extra.infant}
          type="number"
          onChange={({ target: { value } }) => {
            updateWithKey('infant', value);
          }}
        />
      </div>
    </div>
  );
}

export default SingleExtra;



// WEBPACK FOOTER //
// ./src/app/components/integration/export/export-content-preview/single-extra.jsx